function Footer() {
  return (
    <div
      className="pt-3 pb-3"
      style={{
        width: "100%",
        backgroundColor: "red",
        color: "white",
        textAlign: "center",
      }}
    >
      {/* Supported By */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
          marginBottom: "10px",
          flexWrap: "wrap",
        }}
      >
      <img
          src="/images/adf.webp" 
          alt="Adroid Foundation"
          style={{
            height: "40px",
            width: "auto",
            objectFit: "contain",
          }}
        />
        <span
          style={{
            fontSize: "16px",
            fontWeight: "500",
          }}
        >
          Supported by Adroid Foundation
        </span>

        
      </div>

      {/* Divider */}
      <div
        style={{
          width: "90%",
          height: "1px",
          backgroundColor: "rgba(255,255,255,0.3)",
          margin: "0 auto 10px",
        }}
      />

      {/* Copyright */}
      <div style={{ fontSize: "14px" }}>
        © <span>{new Date().getFullYear()}</span>{" "}
        <strong>ADROIDCONNECTZ PRIVATE LIMITED</strong> | All Rights Reserved.
      </div>
    </div>
  );
}

export default Footer;